module.exports = __webpack_public_path__ + "media/components/assets/sujung_11-ea572ee4e0e501455ebea29cb592a087.png";